import { EOfferSpendByAccountView, EOfferSpendByOfferScopeView, EOfferSpendByOfferView } from '../types'

export const offerSpendViewByAccountSearchParams = (
	viewBy?: string | null
): EOfferSpendByAccountView | null => {
	switch (viewBy) {
		case EOfferSpendByAccountView.Day:
			return EOfferSpendByAccountView.Day
		case EOfferSpendByAccountView.Month:
			return EOfferSpendByAccountView.Month
	}
	return null
}

export const offerSpendViewByOfferSearchParams = (
	viewBy?: string | null
): EOfferSpendByOfferView | null => {
	switch (viewBy) {
		case EOfferSpendByOfferView.Day:
			return EOfferSpendByOfferView.Day
		case EOfferSpendByOfferView.Month:
			return EOfferSpendByOfferView.Month
	}
	return null
}

export const offerSpendViewByOfferScopeSearchParams = (
	viewBy?: string | null
): EOfferSpendByOfferScopeView | null => {
	switch (viewBy) {
		case EOfferSpendByOfferScopeView.Day:
			return EOfferSpendByOfferScopeView.Day
		case EOfferSpendByOfferScopeView.Month:
			return EOfferSpendByOfferScopeView.Month
	}
	return null
}